import React, { useState, useEffect } from "react";
import { TextField, InputAdornment } from "@mui/material";
import EmailIcon from '@mui/icons-material/Email';
import { useFormik } from "formik";
import * as Yup from "yup";
import useAuth from "../hooks/useAuth";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from "axios";
import enLogo from "../assets/tagi5-final-logo.png";
import { DOMAIN } from "../Constant";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import axiosInstance from '../utilities/axiosInstance';
import "../styles/signin.scss";
import userIcon from "../assets/uil_user.svg";
import lockIcon from "../assets/password-linear.svg";
import GradientInputBox from "./GradientInputBox";
import { showAlert } from "./AlertPopup";

const SignIn = () => {
  const { setAuth } = useAuth();
  const [isOpen] = useState(true);
  const [isEmailVisible, setIsEmailVisible] = useState(false);
  const [buttonTitle, setButtonTitle] = useState('Login');

  let navigate = useNavigate();
  let appPort = process.env.REACT_APP_PORT || 3000;
  const [isFormVisible, setIsFormVisible] = useState(true);

  useEffect(() => {
    const storedAuth = sessionStorage.getItem('auth');
    if (storedAuth) {
      setAuth(JSON.parse(storedAuth));
      // No need to navigate here, RequireAuth will handle it
    } else {
      setIsFormVisible(true);
    }
  }, [setAuth]);


  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
      email: ""
    },
    validationSchema: Yup.object({
      username: (!isEmailVisible) ? Yup.string().min(5).required("Username is required") : '',
      password: (!isEmailVisible) ? Yup.string().min(5).required("Password is required") : '',
      email: (isEmailVisible) ? Yup.string().email("Please enter a valid email").required("Email is required") : '',
    }),

    onSubmit: (values) => {
      let baseURL;
      if (!isEmailVisible) {
        baseURL = `${DOMAIN}/api/login`;

        axios.post(baseURL, values, { withCredentials: true }).then((response) => {
          if (response.status === 200) {
            localStorage.setItem('token', response.data.token);
            sessionStorage.setItem('auth', JSON.stringify(response.data)); // Store auth in sessionStorage
            setAuth(response.data);
            if (response.data.profile_role === 1) {
              navigate("/projects");
            } else if (response.data.profile_role === 3) {
              navigate("/tagger");
            } else if (response.data.profile_role === 4) {
              navigate("/reviewer");
            } else if (response.data.profile_role === 2) {
              navigate("/manager");
            }
            axiosInstance.post(`/storePort`, { port: appPort })
              .then((response) => {
                // Handle the response if needed
                console.log("Port stored in the Database:", response.data.message);
              })
              .catch((error) => {
                console.error("Error storing port in the backend:", error);
              });
            /**
             * END
             */
            setIsFormVisible(false);
          } else {
            console.warn("check the response")
          }
          setAuth(response.data);
        }).catch((error) => {
          showAlert(error.response.data.message, "error");
        });
      } else {
        if (values.email) {
          baseURL = `${DOMAIN}/api/forgotpassword/${values.email}`;
          axios.get(baseURL).then(response => {
            if (response.status === 200) {
              showAlert("Password has been sent to your email id.", "success");
            } else {
              console.warn("check the response")
            }
          }).catch(error => {
            showAlert(error.response.data.message, "error");
          });
          navigate('/signin', { replace: true }); // Go back to sign-in after password reset request
        } else {
          showAlert("please enter your email", "error");
        }
      }
    }
  });
  function showEmailField() {
    setButtonTitle('Submit');
    setIsEmailVisible(true);
  }

  function showLoginField() {
    setButtonTitle('Login');
    setIsEmailVisible(false);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[url('./assets/login-bg-mobile.jpg')] lg:bg-[url('./assets/login-bg.jpg')] bg-cover bg-center">
      <div className="flex flex-col lg:flex-row w-full max-w-[1200px] overflow-hidden lg:min-h-[544px]">

        <div className="hidden lg:flex w-3/5"></div>

        <div className="w-full lg:w-2/5 p-10 flex flex-col justify-center items-center lg:items-end">
          <div className="w-[420px] py-[40px] px-[35px] custom-shadow">
            {isFormVisible && (
              <form className="signin-form-main">

                <div className='top-section'>
                  <img style={{ width: isOpen ? "158px" : "50px" }} src={enLogo} alt='logo' />
                </div>
                {/* Login page starts here*/}
                <div>
                  {!isEmailVisible && (
                    <>
                      <label className="block mb-2 text-base leading-6 font-medium text-gray-main ml-6">Username</label>
                      <GradientInputBox>
                        <TextField
                          name="username"
                          type="text"
                          variant="standard"
                          fullWidth
                          placeholder="Enter username"
                          value={formik.values.username}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <img src={userIcon} alt="lock" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            input: {
                              padding: 0,
                              fontSize: '16px',
                              fontFamily: 'Poppins, sans-serif'
                            },
                          }}
                        />
                      </GradientInputBox>
                    </>
                  )}
                </div>

                {formik.touched.username && formik.errors.username && !isEmailVisible && (
                  <div className="text-red-500 text-sm mb-2 ml-6 mt-2">{formik.errors.username}</div>
                )}

                <div>
                  {!isEmailVisible && (
                    <>
                      <label className="block mb-2 text-base leading-6 font-medium text-gray-main ml-6 mt-5">Password</label>
                      <GradientInputBox>
                        <TextField
                          name="password"
                          type="password"
                          variant="standard"
                          fullWidth
                          placeholder="Enter password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          InputProps={{
                            disableUnderline: true,
                            startAdornment: (
                              <InputAdornment position="start">
                                <img src={lockIcon} alt="lock" style={{ width: '24px', height: '24px', marginRight: '8px' }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            input: {
                              padding: 0,
                              fontSize: '16px',
                              fontFamily: 'Poppins, sans-serif'
                            },
                          }}
                        />
                      </GradientInputBox>
                    </>
                  )}

                </div>

                {formik.touched.password && formik.errors.password && !isEmailVisible && (
                  <div className="text-red-500 text-sm mt-2 ml-6">{formik.errors.password}</div>
                )}

                {/* Email field shown only if isEmailVisible is true */}
                {isEmailVisible && (
                  <div>
                    <GradientInputBox>
                      <TextField
                        name="email"
                        type="email"
                        variant="standard"
                        fullWidth
                        placeholder="Enter your email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        // helperText={formik.touched.email && formik.errors.email}
                        InputProps={{
                          disableUnderline: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <EmailIcon className="text-gray-500" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          input: {
                            padding: 0,
                            fontSize: '16px',
                          },
                          '& .MuiFormHelperText-root': {
                            marginLeft: 0,
                          },
                        }}
                      />
                    </GradientInputBox>
                  </div>
                )}

                {formik.touched.email && formik.errors.email && isEmailVisible && (
                  <div className="text-red-500 text-sm mt-1 ml-6">{formik.errors.email}</div>
                )}

                {/* "Forgot Password?" section when email is hidden */}
                {!isEmailVisible && (
                  <div className="text-center mb-[30px] mt-5">
                    <p className="text-gray-main text-base">
                      Forgot Password?{" "}
                      <button
                        onClick={showEmailField}
                        className="text-blue-600 hover:underline font-medium p-0 m-0 bg-transparent border-none cursor-pointer"
                        type="button"
                      >
                        Click here
                      </button>
                    </p>
                    <input
                      type="hidden"
                      name="hidForgotPassword"
                      id="hidForgotPassword"
                      value={isEmailVisible}
                    />
                  </div>
                )}

                {/* "Go back to login" section when email is visible */}
                {isEmailVisible && (
                  <div className="text-center mb-4 mt-5">
                    <p className="text-gray-main text-base">
                      Go back to Login?{" "}
                      <button
                        onClick={showLoginField}
                        className="text-blue-600 hover:underline font-medium p-0 m-0 bg-transparent border-none cursor-pointer"
                        type="button"
                      >
                        Click here
                      </button>
                    </p>
                    <input
                      type="hidden"
                      name="hidForgotPassword"
                      id="hidForgotPassword"
                      value={!isEmailVisible}
                    />
                  </div>
                )}

                <div className="text-center group">
                  <button
                    className="text-white text-base font-semibold rounded-[30px] py-[10px] px-[76px] transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                    type="submit"
                    onClick={formik.handleSubmit}
                  >
                    {buttonTitle}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>


      </div>
    </div>
  );
};

export default SignIn;